import React from 'react'
import { Checkbox } from 'primereact/checkbox'

const CheckboxInput = (props: {
    value: boolean
    onChangeCallback: (input?: any) => void
    classes?: string
    name?: string
    label?: string
    disabled?: boolean
}) => {
    const { value, onChangeCallback, name, label, classes, disabled } = props
    const id = name + '_cb_id'
    return (
        <div
            className={`wardrobe-checkbox p-d-flex p-ai-center ${
                classes ? classes : ''
            }`}>
            <Checkbox
                inputId={id}
                value={label}
                checked={value}
                onChange={onChangeCallback}
                disabled={disabled}
            />
            {label && (
                <label htmlFor={id} className="p-checkbox-label p-mb-0 p-ml-2">
                    {label}
                </label>
            )}
        </div>
    )
}

export default CheckboxInput
